let domLoaded = false;
let igReady = !!window.igData?.user;
let igFailed = false;

function handleExperiments() {
  if (!domLoaded || !(igReady || igFailed)) return;

 // Test: Free Shipping Threshold at $500 with Cart Progress Bar
 const freeShippingTest = window.igData?.user.getTestGroup("e19a5d9e-5b50-4423-a5ee-e047923a2cae");
 if (freeShippingTest?.id === "852368e9-d177-4894-a431-9f1205dede6b") {
   document.body.classList.add('c-freeShippingVarA');
 } else {
   document.body.classList.add('c-freeShippingControl');
 }

  // Test: V_IG_PDP_02 | PDP Bundle Discount — Knife + WorkSharp Pivot Plus Sharpener (10% Off)
  const igPdp02 = window.igData?.user?.getTestGroup?.("538bbb60-80d9-42f2-8cab-8212aae8a4b2");
  if (igPdp02?.id === "16f0c747-4795-4840-88e2-4a4717894003") {
    document.body.classList.add("c-pdpBundleDiscountVarA");
  } else {
    document.body.classList.add("c-pdpBundleDiscountControl");
  }

  // Test: V_IG_MIX_04 | Giveaway Entry Count + Progress in Cart Drawer
  const igMix04 = window.igData?.user?.getTestGroup?.("cb18d76f-dd62-48b5-b93a-587217ac6e83");
  if (igMix04?.id === "9d5d3fd4-e254-4fdb-8065-b3a14ca55e96") {
    document.body.classList.add("c-mix04VarA");
  } else {
    document.body.classList.add("c-mix04Control");
  }

  document.dispatchEvent(new CustomEvent("c:experiments-applied"));
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});

window.addEventListener(
  "error",
  (e) => {
    if (!/cdn\.intelligems\.io/.test(e.target?.src || "")) return;
    igFailed = true;
    handleExperiments();
  },
  true
);
